import { apiHandler } from '.';
import axios from 'axios';
import {
    saveCatagory,
    saveaboutus,
    savestoreconfig,
    savelandingData,

} from '../features/HomePageSlice/homeDataSlice';
import { endpoint } from './endpoint';
import { STORE_CONFIG, CATEGORIES, ABOUTUS, GETURLDATA } from '../assets/graphql';
import { useSelector } from 'react-redux';

export const getHomepageData = ({ dispatch }) => {
   
    // const getSession = localStorage.getItem('loginCheck');
    // const currentUrl = window.location.href;
    // const parts = currentUrl.split("/");
    // let getURL = parts[parts.length - 1];
    // getURL = getURL ? getURL : "default";

    const getURL = localStorage.getItem('loginURL');

    return axios
        .all([
            apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": {},
                    "query": CATEGORIES
                },
            }),
            apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": {},
                    "query": ABOUTUS
                },
            }),
            apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": {},
                    "query": STORE_CONFIG
                },
            }),
            apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": { getURL },
                    "query": GETURLDATA
                },
            }),
             
        
     
        ])
        .then(
            axios.spread((categories, aboutus,  storeconfig, landingData ) => {
              

                if (!categories.data.error_code) {
                    dispatch(saveCatagory(categories.data.categoryList));
                }
                if (!aboutus.data.error_code) {
                    dispatch(saveaboutus(aboutus.data.cmsBlocks.items));
                }
                if (!storeconfig.data.error_code) {
                    // console.log("scopeData", storeconfig.data);
                    dispatch(savestoreconfig(storeconfig.data.storeConfig));
                }
                if (!landingData.data.error_code) {
               
                    dispatch(savelandingData(landingData.data.prelogin));
                }
           
                // if (!categoryBreadcrumbs.data.error_code) {
                //     dispatch(saveaboutus(categoryBreadcrumbs.data.category));
                // }
            })
        );
};
